<template>
    <div>
        <div class="row mb-2" v-for="(table, tidx) in control" :key="`TABLE-${tidx}`">
            <small>{{ getTableControlName(table) }}</small><br>
            <div class="table table-sm  medezTables noteTable cutescroll cursor-context-menu b-table-sticky-header table-responsive">
                <table class="table b-table b-table-selectable b-table-select-single mb-2">
                    <thead>
                        <tr>
                            <th class="table-b-table-default" v-for="(column, index) in getColumns(table)" :key="`th-${index}`">
                                <div>{{ column.name }}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(row, idx) in getRows(table)">
                            <tr v-if="!showOnlyChange || !isRowEmpty(table, row.rowKey)" :key="`tr-${idx}`">
                                <td v-for="(col, i) in getColumns(table)" :key="`td-${idx}${i}`">
                                    <div class="p-1">
                                        <ul class="mb-0">
                                            <li v-for="(cell, x) in getCell(table, row.rowKey, col)" :key="`li-${idx}${i}${x}`" :class="cell.class">
                                                <span :class="cell.class">{{ cell.value }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '@/common/utils'

export default {
    name: 'AuditNoteTable',

    props: {
        control: Array,
        showOnlyChange: Boolean,
        auditableTableControl: Array
    },

    methods: {
        getColumns(table) {
            return this.showOnlyChange ? 
                table.header.filter(x => x.rowsWithData > 0) :
                table.header;
        },

        getRows(table) {
            return table.body;
        },

        getCell(table, rowKey, column) {
            const row = table.body.find(x => x.rowKey == rowKey);
            if (row) {
                const cell = row.columns.find(x => x.column == column.name);
                if (cell) {
                    const values = [];
                    if (cell.status == 'NEW') {
                        values.push({value: this.getValue(cell.value, column.type), class: 'added'});
                    } else if (cell.status == 'DELETE') {
                        values.push({value: this.getValue(cell.old, column.type), class: 'deleted'});
                    } else if (cell.status == 'UPDATE') {
                        values.push({value: this.getValue(cell.value, column.type), class: 'added'});
                        values.push({value: this.getValue(cell.old, column.type), class: 'deleted'});
                    } else if (!this.showOnlyChange) {
                        values.push({value: this.getValue(cell.value, column.type), class: ''});
                    }

                    return values;
                }
            }

            return [];
        },

        getValue(value, type) {
            if (type.toLowerCase() == 'datetime') {
                return Utils.formatterDateToString(value, 'MM/DD/YYYY');
            }
            
            return value;
        },

        isRowEmpty(table, rowKey) {
            const row = table.body.find(x => x.rowKey == rowKey);
            if (row) {
                return row.columnsWithData - row.columnsWithDataUnmodified <= 0; 
            }
            
            return true;
        },

        getTableControlName(table) {
            const tableControl = this.auditableTableControl.find(x => x.controlId == table.recId);
            if (tableControl) {
                return tableControl.name;
            }

            return `${table.tableId} ${table.headerId} ${table.recId}`;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
</style>